import React,{Component} from 'react';
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types';
import comodoimg from '../../images/comodo.png';
class Product extends Component{
    render(){
        const {productdetails,history} = this.props;
        if(productdetails){
            const{heading,price,description,whmcs_id} = productdetails;
            let img = comodoimg;
            let tag = 'comodo'
            return(
                <div className={'SSL-Selector__Product clearfix'}>
                    <div className={`Product__wrapper clearfix Product__wrapper--${tag}`}>
                        <div className={`Product__tag Product__tag--${tag}`}>Best Fit</div>
                        <div className={`Product__container clearfix`}>
                            <img className={`Product__logo`} src={img} alt={`product logo`} />
                            <div className={`Product__heading`}>{heading}</div>
                            <div className={`clear`}></div>
                            <div className={`Product__price`}>
                                <div className={`price__value`}>${price}</div>
                                <div className={`price__currency`}>/yr AUD</div>
                            </div>
                            <div className={`Product__description clearfix`}>{description}</div>
                            <div target={`_blank`} onClick={()=>{
                                history.push(`${history.location.pathname}?a=add&pid=${whmcs_id}`)
                            }} className={`Product__button cleasrfix`}>Add To Cart</div>
                            <div className={`clear`}></div>
                        </div>
                    </div>
                </div>
            )
        }else{
            return('')
        }
    }
}



Product.propTypes = {
    productdetails : PropTypes.object,
    history: PropTypes.object
}


export default withRouter(Product);